import { render } from "./ProductBlock.vue?vue&type=template&id=7ee2f79f&scoped=true"
import script from "./ProductBlock.vue?vue&type=script&lang=js"
export * from "./ProductBlock.vue?vue&type=script&lang=js"

import "./ProductBlock.vue?vue&type=style&index=0&id=7ee2f79f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee2f79f"],['__file',"resources/js/modules/labelinsight-products/components/ProductBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ee2f79f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ee2f79f', __exports__)) {
    api.reload('7ee2f79f', __exports__)
  }
  
  module.hot.accept("./ProductBlock.vue?vue&type=template&id=7ee2f79f&scoped=true", () => {
    api.rerender('7ee2f79f', render)
  })

}


export default __exports__